import request from '@/utils/request';

let merchantApi = {
    // 实时交易查询
    getManage(data, err) {
        return request._get('/shop/merchant/merchant/selectList', data, err);
    },

    // 商户信息详情
    getMerchantDetail(data, err) {
        return request._get('/shop/merchant/merchant/details', data, err);
    }
}

export default merchantApi;




// WEBPACK FOOTER //
// ./src/api/merchant/manage.js